
<template>
  <div class="container-xs mt-6">
    <div class="card">
      <div class="card-content">
        <h1 class="title-md">Forgot Password</h1>        
        <p>If you forgotten or do not know your password, then enter your email address and we will send you an email with a link to reset it.</p>
        <form @submit.prevent="validateBeforeSubmit('forgot-paswword')" data-vv-scope="forgot-paswword">

          <div class="field">
            <label class="label">{{labels.emailLabel}}</label>
            <div class="control has-icon has-icon-right">
              <input name="email" v-model="email" v-validate="'required|email'" :class="{'input': true, 'is-danger': errors.has('forgot-paswword.email') }" type="text" v-on:focus="clear">
              <i v-show="errors.has('forgot-paswword.email')" class="fa fa-warning"></i>
              <span v-show="errors.has('forgot-paswword.email')" class="help is-danger">{{errorMessage}}</span>
            </div>
          </div>
          <div class="field">
            <div class="control">
              <button type="submit" :class="{'button is-primary':true, 'is-loading disabled' : loading }" ><span class="glyphicon glyphicon-off"></span> Submit</button>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>

</template>
<script>
  export default {
    name: 'ForgotPassword',
    data() {
      return {
        email: '',
        description: '',
        labels: [],
        errorMessage: 'Email is required',
        loading: false
      }
    },
    created() {
      this.$http
        .get('/umbraco/surface/AuthenticationSurface/ForgotPassword')
        .then(response => {
          this.labels = response.data.labels;
          this.description = response.data.description
        })
        .catch(error => {
          this.errored = true
        })
    },
    methods: {
      validateBeforeSubmit(scope) {
        this.$validator.validateAll(scope).then((result) => {
          if (result) {
            this.loading = true;
            this.$http.post
              (
                '/umbraco/surface/AuthenticationSurface/PostForgotPassword',
                { email: this.email }
              )
              .then(response => {
                  if (response.data.error)
                    this.loading = false;
                  else if (response.data.redirectURL != "") {
                    this.loading = false;
                    window.location.href = response.data.redirectURL;
                  }

              })
              .catch(error => {
                this.errored = true;
                this.loading = false;
              })

            return;
          }


        });
      },
      clear() {
        this.errored = false;
      },

    }
  }
</script>



// WEBPACK FOOTER //
// src/components/ForgotPassword.vue